import DOMPurify from 'dompurify';

export const sanitizeInput = (input) => {
  if (!input) return input;
  return DOMPurify.sanitize(input.toString().trim(), {
    ALLOWED_TAGS: [], // HTML tag'leri izin verme
    ALLOWED_ATTR: []  // Attribute'leri izin verme
  });
};

export const validateURL = (url) => {
  try {
    const urlObj = new URL(url);
    // Sadece http/https protokollerine izin ver
    if (!['http:', 'https:'].includes(urlObj.protocol)) {
      throw new Error('Geçersiz protokol');
    }
    return urlObj.href;
  } catch {
    throw new Error('Geçersiz URL');
  }
};

export const sanitizeEmail = (email) => {
  if (!email) return email;
  return email.toLowerCase().trim();
};

export const sanitizeAppData = (data) => {
  return {
    name: sanitizeInput(data.name),
    description: sanitizeInput(data.description),
    testUrl: data.testUrl ? validateURL(data.testUrl) : '',
    platform: sanitizeInput(data.platform),
    requirements: data.requirements ? sanitizeInput(data.requirements) : null
  };
};
